import { useState } from "react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Account() {
  const { user, setUser } = useAuth();
  const [form, setForm] = useState({ name: user.name || "", phone: user.phone || "" });
  const [saving, setSaving] = useState(false);

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const { data } = await api.put("/auth/me", form);
      setUser(data);
      toast.success("Profil disimpan");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="container-page max-w-xl py-12" data-testid="account-page">
      <p className="eyebrow">Akun</p>
      <h1 className="mt-2 text-3xl font-bold tracking-tight text-stone-900">Akun Saya</h1>
      <form onSubmit={save} className="card-soft mt-8 space-y-5 p-6 sm:p-8">
        <div className="space-y-2">
          <Label>Email</Label>
          <Input value={user.email} disabled className="h-11 rounded-xl" data-testid="account-email" />
        </div>
        <div className="space-y-2">
          <Label htmlFor="name">Nama</Label>
          <Input id="name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="h-11 rounded-xl" data-testid="account-name-input" />
        </div>
        <div className="space-y-2">
          <Label htmlFor="phone">Nomor WhatsApp</Label>
          <Input id="phone" type="tel" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} placeholder="08xxxxxxxxxx" className="h-11 rounded-xl" data-testid="account-phone-input" />
          <p className="text-xs text-stone-500">Nomor ini ditampilkan ke penyedia hanya setelah Anda menerima penawarannya.</p>
        </div>
        <Button type="submit" disabled={saving} data-testid="account-save-button" className="rounded-xl bg-teal-700 hover:bg-teal-800">Simpan</Button>
      </form>
    </div>
  );
}
